import { useSystemLogs } from '../api/getSystemLogs';
import { GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { LogCategory } from '../../../types/models/SystemLog';
import { formatInTimeZone } from 'date-fns-tz';

export const useSetupSystemLogTable = (
  categoryId: number | undefined,
  fromDate: string | undefined,
  toDate: string | undefined,
  timezone: string,
  timestampFormat: string
) => {
  const { data: systemLogs } = useSystemLogs(categoryId, fromDate, toDate);
  const formatLog = (log: string) => {
    return <Typography variant={'body2'}>{log}</Typography>;
  };
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'user', headerName: 'User', width: 150 },
    { field: 'category', headerName: 'Category', width: 150 },
    {
      field: 'log',
      headerName: 'Log',
      flex: 1,
      renderCell: (params) => formatLog(params.row.log),
    },
    { field: 'timestamp', headerName: 'Time', width: 200 },
  ];
  const rows = (systemLogs || []).map((log) => ({
    ...log,
    user: log.user ? log.user.name : 'System',
    category: LogCategory[log.category],
    timestamp: formatInTimeZone(
      new Date(log.timestamp),
      timezone,
      timestampFormat
    ),
  }));
  return { columns, rows };
};
